import variant from '@jitl/quickjs-wasmfile-release-sync';
import wasmLocation from '@jitl/quickjs-wasmfile-release-sync/wasm?url';
import { newVariant } from 'quickjs-emscripten-core';
import { loadScriptRuntime, type ScriptRuntime } from '$lib/core/script';

/** Loads the script sandbox in the browser, fetching its wasm from where Vite serves it. */
export function loadBrowserScriptRuntime(): Promise<ScriptRuntime> {
  return loadScriptRuntime(newVariant(variant, { wasmLocation }));
}
